import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["instance"]

  initialize() {
    this.forceClose = this.forceClose.bind(this)
  }

  connect() {
    document.addEventListener("turbo:before-render", this.forceClose)
  }

  instanceTargetConnected(el) {
    if (el.dataset.open === "true") {
      // close open modals before opening a new one
      this.forceClose()
      el.showModal()
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-render", this.forceClose)
  }

  open(event) {
    // close open modals before opening a new one
    this.forceClose()
    document.getElementById(event.params.id).showModal()
  }

  close(event) {
    const instance = document.getElementById(event.params.id)
    instance.setAttribute("closing", "")

    Promise.all(instance.getAnimations().map((animation) => animation.finished)).then(() => {
      instance.removeAttribute("closing")
      instance.close()
    })
  }

  backdropClose(event) {
    if (event.target === document.getElementById(event.params.id)) {
      this.close(event)
    }
  }

  forceClose() {
    this.instanceTargets.forEach((instance) => instance.close())
  }
}
